import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { FaQuestionCircle, FaSnapchat } from 'react-icons/fa'

const SelectScoring = () => {
  return (
    <div>
        <Container>
        <Row className='mt-4 shadow-sm p-3 justify-content-between' style={{background:'#F6F7F9',color:'#7D7D7D'}}>
                <Col sm={1} className="me-2 pe-2">
                    <div className='pe-3'>
                        <input type="text" className='text-center pe-3' placeholder='1' id="textInput" style={{height:'40px',border:'1px solid #EAEBEC',width:'140px' }} />
                    </div>

                </Col>
                <Col sm={10} className="pe-0">
                    <div className='bg-white px-2 d-flex justify-content-between align-items-center' style={{height:'40px',border:'1px solid #EAEBEC'}}>
                        <span>What is your activity Level?</span>                       
                    </div>
                </Col>
            </Row>
          <Row className='justify-content-center mt-4'>
            <Col md={8} style={{color:'#777777'}}>
              <div className='mt-4'>
                <p style={{fontSize:'15px',fontWeight:'600'}}>
                  <FaQuestionCircle  className='me-3'/> Answer:
                </p>
                <ul className='ps-5' style={{fontSize:'14px',fontWeight:'600'}}>
                  <li className='mb-2'>Not active at all</li>
                  <li className='mb-2'>Somewhat active</li>
                  <li className='mb-2'>Active</li>
                  <li className='mb-2'>Hyper active</li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
    </div>
  )
}

export default SelectScoring
